import React from 'react';
import { Button, makeStyles, mergeClasses, shorthands } from '@fluentui/react-components';
import { ReactComponent as ThinkLongerIcon } from '../../../../../assets/toolkit/think-longer.svg';
import { customColors, customFonts } from '../../../../../styles';

const trayButtonIcon = '& .toolkitTrayIcon';
const trayButtonIconSvg = '& .toolkitTrayIcon svg';

const useStyles = makeStyles({
    trayButton: {
        height: '32px',
        fontFamily: customFonts.Lato,
        fontSize: '14px',
        fontWeight: '700',
        color: customColors.protivitiDarkBlue,
        ...shorthands.border('1px', 'solid', customColors.protivitiDarkBlue),
        ...shorthands.borderRadius('5px'),
        ...shorthands.padding('0px', '12px'),
        backgroundColor: customColors.white,
        whiteSpace: 'nowrap',
        transition: 'all 0.2s ease',

        [trayButtonIconSvg]: {
            color: customColors.protivitiDarkBlue,
            transition: 'all 0.2s ease',
        },

        '&:hover': {
            backgroundColor: customColors.protivitiDarkBlue,
            color: customColors.white,
            ...shorthands.border('1px', 'solid', customColors.protivitiDarkBlue),

            [trayButtonIcon]: {
                backgroundColor: 'transparent',
            },

            [trayButtonIconSvg]: {
                color: customColors.white,
            },
        },

        '&:active': {
            backgroundColor: customColors.protivitiDarkBlue,
            color: customColors.white,
            transition: 'all 0s',

            [trayButtonIcon]: {
                backgroundColor: 'transparent',
            },

            [trayButtonIconSvg]: {
                color: customColors.white,
            },
        },
    },
    trayButtonActive: {
        backgroundColor: customColors.protivitiDarkBlue,
        color: customColors.white,

        [trayButtonIconSvg]: {
            color: customColors.white,
        },

        '&:hover': {
            backgroundColor: customColors.protivitiDarkBlue,
            color: customColors.white,
        },
    },
});

interface ThinkLongerButtonProps {
    isEnabled: boolean;
    onToggle: () => void;
}

const ThinkLongerButton: React.FC<ThinkLongerButtonProps> = ({ isEnabled, onToggle }) => {
    const styles = useStyles();

    return (
        <Button
            className={mergeClasses(styles.trayButton, isEnabled && styles.trayButtonActive)}
            appearance="transparent"
            icon={<ThinkLongerIcon className="toolkitTrayIcon" />}
            aria-pressed={isEnabled}
            onClick={onToggle}
        >
            Think Longer
        </Button>
    );
};

export default ThinkLongerButton;
